var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBallonAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8126 10.8894C18.1375 14.1655 15.8963 18.0012 13.1096 18.8349L14.1021 20.4855C14.5029 21.152 14.0218 22 13.2428 22H10.7697C9.99075 22 9.50958 21.152 9.91037 20.4855L10.9029 18.8349C9.37321 18.3773 8.00791 17.0151 6.97578 15.3374C11.131 14.5432 15.1364 13.044 18.8126 10.8894Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.44674C18.9356 7.62483 18.7289 6.84279 18.4045 6.12512C14.3019 8.46036 9.80264 9.98765 5.15126 10.6395C5.32001 11.5607 5.61704 12.5343 6.01904 13.4789C10.2644 12.7408 14.3552 11.2275 18.08 8.99755L19 8.44674Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.64079C9.32311 8.01888 13.505 6.59717 17.3259 4.43639C16.0394 2.94462 14.1334 2 12.0063 2C8.25253 2 5.18739 4.94173 5 8.64079Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallonAlt1);
export default __webpack_public_path__ + "static/media/ballon-alt-1.6f119df897e031a93e77d0cd90ea282a.svg";
export { ForwardRef as ReactComponent };